import { useEffect, useState } from "react";
import { NewsEvent, api, isError } from "../api";

const POLL_MS = 2000;

export interface NewsState {
  events: NewsEvent[];
  asOf: string | null;
}

export function useNewsPoll(hoursForward = 24): NewsState {
  const [events, setEvents] = useState<NewsEvent[]>([]);
  const [asOf, setAsOf] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function tick() {
      const r = await api.newsEvents(hoursForward);
      if (cancelled) return;
      if (isError(r)) {
        setEvents([]);
        setAsOf(null);
      } else {
        setEvents(r.events);
        setAsOf(r.as_of);
      }
    }
    void tick();
    const id = setInterval(tick, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [hoursForward]);

  return { events, asOf };
}
